<template>
    <el-dialog v-model="dialogShow" title="开悟作文智能分析" width="400px" center :close-on-click-modal="false" :show-close="false">
        <div class="AIpopupBox">
            <div class="AIpopupTip">
                <span>{{tipActive}}</span>
                <el-icon color="#ef8b25">
                    <Loading />
                </el-icon>
            </div>
            <div class="AIpopupNotice">
                {{noticeActive}}
            </div>
            <div class="AIpopupBtn" v-show="cancelShow">
                <el-button icon="close" style="width:100%" type="info" color="#dadbde" round @click="cancelHandle">取消操作</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, defineProps, defineEmits, onBeforeUnmount } from 'vue';
const tips = ['正在初始化分析引擎...',
    '正在处理数据...',
    '正在应用智能算法...',
    '正在生成分析...',
    '正在优化结果...',
    '即将完成...'
]
const notices = [
    '✨ 这本书将带来什么改变？',
    '•	✅ 思维升级：从“套模板”到“创意思维”，写出独一无二的个性作文；',
    '•	✅ 效率提升：快速突破“没素材”“没灵感”的瓶颈，下笔如有神；',
    '•	✅ 素养奠基：通过写作培养观察力、逻辑力、表达力，助力全科学习！',
    '•	“教材不是学生的世界，世界才是最好的教材!” 让作文真正扎根于生活，写出有血有肉的真情实感。',
    '•	书中融入AI技术辅助素材整理和框架设计，但始终强调“深度思想与情感无法被AI取代”，避免学生依赖科技而丧失创造力。'
]
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    },
    cancelShow: {
        type: Boolean,
        default: true
    },
})
const dialogShow = ref(props.popupShow)
const tipActive = ref('')
const noticeActive = ref('')
let timer = null, noticetimer = null;
const emitList = defineEmits(['close'])

function cancelHandle() {
    emitList('close')
}

onMounted(() => {
    let n = 0, noticeNum = 0
    tipActive.value = tips[n]
    noticeActive.value = notices[noticeNum]
    timer = setInterval(() => {
        n++;
        if (n < tips.length) {
            tipActive.value = tips[n]
        } else {
            timer && clearInterval(timer)
            timer = null
        }
    }, 2000)
    noticetimer = setInterval(() => {
        noticeNum++;
        if (noticeNum < notices.length) {
            noticeActive.value = notices[noticeNum]
        } else {
            noticetimer && clearInterval(noticetimer)
            noticetimer = null
        }
    }, 3000)
})
onBeforeUnmount(() => {
    timer && clearInterval(timer)
    timer = null
    noticetimer && clearInterval(noticetimer)
    noticetimer = null
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.AIpopupBox {
    padding: 10px;
    border: 1rpx solid #ddd;
    border-radius: 10px;
    background: #f4f4f5;
}

.AIpopupTip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    color: $base-color;
}

.AIpopupNotice {
    padding: 10px;
    background: #dadbde;
    border-radius: 10px;
}

.AIpopupBtn {
    width: 100px;
    text-align: center;
    margin: 10px auto 0;
}
</style>
